import React, { Component, PropTypes, useState } from 'react';
import { Field, reduxForm, getFormSyncErrors } from 'redux-form';
import {useSelector, connect, useDispatch} from 'react-redux';
import { CButton, CFormSwitch, CFormLabel } from 'compat/coreui';
import axios from 'axios';
import {useNavigate} from 'react-router-dom';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import { ToastContainer, toast } from 'react-toastify';
import moment from 'moment';



const required = (value) => (value ? undefined : "Required");


const renderField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <React.Fragment>
      <input {...input} placeholder={label} type={type} className="error-input socialbtn" />
      {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
  </React.Fragment>
)

const weekday = [
	{
		name: "Monday",
		value: true
	}, {
		name: "Tuesday",
		value: true
	}, {
		name: "Wednesday",
		value: true
	}, {
		name: "Thursday",
		value: true
	}, {
		name: "Friday",
		value: true
	}, {
		name: "Saturday",
		value: true
	}, {
		name: "Sunday",
		value: true
	}];

const StepThree = (props) => {
	const [picture, setPicture] = useState([])
	const { handleSubmit, reset, setPage } = props;
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const [photos, setPhotos] = useState(null);
	const [hoursOperationTime, setHoursOperationTime] = useState(weekday.map(day => ({
		day: day.name,
		isWorking: false,
		from: '',
		to: '',
		whole_day: true
	})))

	function onChangetime(value) {
    // console.log("value ===>", value );
  }


	const values = useSelector(state => state.form.sellerForm && state.form.sellerForm.values);
		
	const validate = (e) =>{
		e.preventDefault()
		if (!props.valid) {
			// props.touch("address1");
			// props.touch("city");
			// props.touch("state");
		} else {
			// setPage(4)
		}
	}


	const amenities = [
	{
		name: "Delivery",
		value: true
	}, {
		name: "Credit Card Accepted",
		value: true
	}, {
		name: "Security",
		value: true
	}, {
		name: "On-Site Smoking",
		value: true
	}, {
		name: "Terminal Paitent Discount",
		value: true
	}, {
		name: "On-site ATM",
		value: true
	}, {
		name: "Wheelchair Accessible",
		value: true
	}, {
		name: "Veteran Paitent Discount",
		value: true
	}];

	const submit = (e) =>{
    e.preventDefault()
    if (!props.valid) {
      // props.touch("address1");
      // props.touch("city");
      // props.touch("state");

    } else {

        let url= `${process.env.REACT_APP_APP_API_URL}/api/auth/registerForSeller`
        let formData = new FormData();
        formData.append("plan", props.planId)
        formData.append("businessName", values.businessName);
        formData.append("businessEmail", values.businessEmail);
        formData.append("phone", values.phone);
        formData.append("webUrl", values.webUrl);
        formData.append("businessType", values.businessType);
        formData.append("address", values.address1);
        formData.append("address2", values.address2 || '');
        formData.append("city", values.city);
        formData.append("state", values.state);
        formData.append("operationTime", JSON.stringify(hoursOperationTime));
        formData.append("photos", photos);
        formData.append("pincode", values.zipcode);
        formData.append("password", values.userPassword);
   
        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }
        return axios.post(url, formData, config).then(response => {
          if(response.status === 200){
            toast.success("Registration Successful!");
            dispatch(reset('sellerForm'));
            navigate('/profile')
          }
        }).catch(e => {
          if (e && e.response && e.response.data.message) {
            toast.error(e.response.data.message);
          }
        })
    }
  }


		return (
			<div className="step_wrap">
				<div >
					<form  onSubmit={handleSubmit(submit)}>
						<div className="profile_wrap">
							<div className="profile_img">
								<i className="fa fa-camera" aria-hidden="true"></i>
							</div>
							<div>
								<div className="fileUpload btn btn-primary">
									<span>Upload</span>
									{/*<input type="file" className="upload" name="photos" onChange={(e) => props.setPic(e.target.files[0])}/>*/}
									<input type="file" className="upload" name="photos" onChange={(e) => setPhotos(e.target.files[0])}/>
								</div>
								<p><span style={{color: 'red'}}>Note</span>: Uploading a profile image will greatly increase the clicks to your profile!</p>
							</div>
						</div>
						<div className="step_three-hours">
							<h2>Hours of Operation</h2>
							{/*<div className="form-container clearfix">
								{weekday.map((w, i) => <div key={i} className="step-switch">
									<span className="name_css">{w.name}</span>
									<div>
										<CFormSwitch
											color="info"
											shape="pill"
											size="lg"
											variant="3d"
										/>
									</div>
									<input type="time" name= "operationTime" className="time_css"/>
								</div>
								)}
							</div>*/}
							{hoursOperationTime.map((w, i) => <div key={i} className="step-switch p-3">
								<span className="name_css">{w.day}</span>
								<div className="d-flex">
								  <CFormSwitch
								    color="success"
								    shape="pill"
								    size="lg"
								    variant="3d"
								    value={w.isWorking}
								    onChange={(e,value) => {
								      var _hours = hoursOperationTime.slice()
								      _hours[i].isWorking = !_hours[i].isWorking
								      setHoursOperationTime(_hours)
								    }}
								  />
								  {(!w.whole_day) && <React.Fragment>
								    <TimePicker
								      style={{ width: 100 }}
								      showSecond={false}
								      className="xxx"
								      defaultValue={moment()}
								      onChange={onChangetime}
								    />,<TimePicker
								      style={{ width: 100 }}
								      showSecond={false}
								      className="xxx"
								      defaultValue={moment()}
								      onChange={onChangetime}
								    />
								  </React.Fragment>}
								  <div className="time_css">
								    <input type="checkbox" name="operationTime" checked={w.whole_day}
								      onChange={(e,value) => {
								        var _hours = hoursOperationTime.slice()
								        _hours[i].whole_day = !_hours[i].whole_day
								        setHoursOperationTime(_hours)
								      }}
								    />
								    <CFormLabel>24 Hours</CFormLabel>
								  </div>
								</div>
							</div>)}
						</div>
						<div className="social_section">
							<h2>Social Media</h2>
							<div className="form-container clearfix">
								<div className="form-group">
									<div className="col-md-6">
										<label><i className="fa fa-facebook fa-fw"></i>facebook.com/</label><br />
										<input type="text" name="fb" className="socialbtn" />
									</div>
									<div className="col-md-6">
										<label><i className="fa fa-twitter"></i>Twitter.com/</label><br />
										<input type="text" name="fb" className="socialbtn"/>
									</div>
								</div>
								<div className="form-group">
									<div className="col-md-6">
										 <label><i className="fa fa-google fa-fw"></i>plus.google.com/</label><br />
										<input type="text" name="fb" className="socialbtn"/>
									</div>
									<div className="col-md-6">
										<label><i className="fa fa-pinterest fa-fw"></i>pinterest.com/</label><br />
										<input type="text" name="fb" className="socialbtn"/>
									</div>
								</div>
							</div>
						</div>
						<section>
							<h2>Amenities & Menu</h2>
							<div className="form-container clearfix">
								{amenities.map((w, i) => <div key={i} className="step-switch"> 
									<span style={{width: '200px', fontSize: '16px'}}>{w.name}</span>
									<div>
										<CFormSwitch
											color="info"
											shape="pill"
											size="lg"
											variant="3d"
										/>
									</div>
								</div>
								)}
							</div>
						</section>
						<section className="strain_css">
							<h2>Add your strains & products</h2>
							<div>
								<input type="radio" id="" name="SaleSoftware" />
		  						<label htmlFor="SaleSoftware">Sync my point-of-sale software</label>
							</div>
							<div>
								<input type="radio" id="" name="AddMenu" />
		  						<label htmlFor="AddMenu">I'll add my menu afterwards</label>
							</div>
							<CButton  color="warning" variant="outline" className="m-4" onClick={() => {props.setPage(2)}}>Prev</CButton>
	                  		<CButton  color="success" type="submit" className="m-4" onClick={(e) => {submit(e)}}>Submit</CButton>
						</section>
					</form>
				</div>
				<div className="col-md-3 hideCol">
					<h5>Business Information</h5>
					<hr/>
					<p style={{fontSize: '15px'}}>
						Make sure to set your hours of operation 
						and fill out as much as you can on this page.
						While things like profile image and
						socila media accounts aren't required,
						they will help you gain transaction on site and
						make ypur profile more visible in search result.
					</p>
				</div>
			</div>
	);
}

let MainReduxForm = reduxForm({form: 'sellerForm', destroyOnUnmount: false})(StepThree)

export default MainReduxForm = connect((state) => ({
  synchronousError: getFormSyncErrors("sellerForm")(state), // change name here
}))(MainReduxForm);


